import { hasAnySim, isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta09Model,
  ConsultaSeguimentoPergunta09TrazPraVoceEnum,
} from './model-consultaSeguimentoPergunta09'

const pergunta09TrazPraVoceEnumValues = Object.values(ConsultaSeguimentoPergunta09TrazPraVoceEnum)

export function isPergunta09TrazPraVoceAllNao(
  value: ConsultaSeguimentoPergunta09Model['PERGUNTA_09_TRAZ_PRA_VOCE']
): boolean {
  return isAllNao(value, pergunta09TrazPraVoceEnumValues)
}

export function hasPergunta09TrazPraVoceAnySim(
  value: ConsultaSeguimentoPergunta09Model['PERGUNTA_09_TRAZ_PRA_VOCE']
): boolean {
  return hasAnySim(value)
}
